import { Scene } from "@babylonjs/core/scene";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { ROTATE_FRAMES } from "./constants";

// 90° 左右回転アニメ：rotation.y を deltaY だけ補間で加算
// speedRatio: アニメ速度倍率（デフォルト 1.0）。画面側でスピードを動的に変更するため。
export const performCharRotate = (
  scene: Scene,
  node: AbstractMesh,
  deltaY: number,
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();
    const startY = node.rotation.y;
    const anim = new Animation(
      "charRotate",
      "rotation.y",
      ROTATE_FRAMES,
      Animation.ANIMATIONTYPE_FLOAT,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    anim.setKeys([
      { frame: 0, value: startY },
      { frame: ROTATE_FRAMES, value: startY + deltaY },
    ]);
    const a = scene.beginDirectAnimation(node, [anim], 0, ROTATE_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => resolve();
  });
